import { CustomLiveFeedbackType } from 'Types/CustomTask.types'
import classes from './LiveFeedback.module.less'
import CloseOutlined from '@ant-design/icons/lib/icons/CloseOutlined'
import { useMemo } from 'react'
import { Divider } from 'antd/lib'
import MarkdownRenderer from 'Components/common/MarkdownRenderer/MarkdownRenderer'

type LiveFeedbackModalPropsType = {
    liveFeedbackDetails: CustomLiveFeedbackType | null
    setLiveFeedbackDetails: (data: CustomLiveFeedbackType | null) => void
}

export const LiveFeedbackModal = (props: LiveFeedbackModalPropsType) => {
    const disclaimer = useMemo(() => {
        return (
            <div className={classes.disclaimer}>
                <p>Hey there! Just a quick note about this feedback:</p>
                <ul>
                    <li>It's generated via an AI, so be aware that it might have mistakes.</li>
                    <li>Feel free to use it to spark improvements in your work.</li>
                    <li>Trust your instincts - you know your work best!</li>
                    <li>AI's not perfect, so take any oversights with a grain of salt.</li>
                </ul>
                <p>Happy creating!</p>
            </div>
        )
    }, [])

    const feedbackContent = useMemo(() => {
        if (!props.liveFeedbackDetails) return null

        return Object.entries(props.liveFeedbackDetails).map(([key, value], index) => (
            <div key={key} className={classes.feedbackItem}>
                <p className={classes.key}>
                    {index + 1}. {value.title}
                </p>
                <p>
                    <strong>Prediction:</strong> {value.prediction}
                </p>
                <p className={classes.reasoning}>
                    <strong>Reasoning:</strong>
                    {/* The ML team's API is unable to parse the string properly. The string may sometimes start with ": " or ":" so we replace that with empty string. The string may end with ", " or "," so we replace that too with empty string. */}
                    <MarkdownRenderer
                        children={value.reasoning
                            .replace(/^(?:": "|":")/, '')
                            .replace(/(?:","| ", ")$/, '')}
                        escapeNewlines={true}
                        escapeBackslashses={false}
                    />
                </p>
            </div>
        ))
    }, [props.liveFeedbackDetails])

    if (!props.liveFeedbackDetails) {
        return null
    }

    return (
        <>
            <div className={classes.popupOverlay} />
            <div className={classes.popupContainer} data-testid="plagiarism-popup">
                <div className={classes.header}>
                    <span>Live Feedback</span>
                    <CloseOutlined onClick={() => props.setLiveFeedbackDetails(null)} />
                </div>
                <div className={classes.content}>
                    {disclaimer}
                    <Divider className={classes.divider} />
                    {feedbackContent}
                </div>
            </div>
        </>
    )
}
